module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-14-61cb1447.svg";